// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ConfiguracoesSistema_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/configuracoes_sistema/save
 *
 * Creates or updates a system configuration.
 * If config_sistema_id > 0, updates existing; otherwise creates new.
 */
import { registerContract } from './validate'

export interface ConfiguracoesSistema_SaveInput {
config_sistema_id?: number
config_sistema_nome?: string
config_sistema_valor?: string
config_sistema_descricao?: string
config_sistema_franquia_id?: number
}

registerContract('ConfiguracoesSistema_SaveInput', {
  config_sistema_id:          { type: 'number',  required: false },
  config_sistema_nome:        { type: 'string',  required: false },
  config_sistema_valor:       { type: 'string',  required: false },
  config_sistema_descricao:   { type: 'string',  required: false },
  config_sistema_franquia_id: { type: 'number',  required: false },
})
